


import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { Header } from '../../Components/Layout/Header.jsx'
import { GameDetails } from '../../Components/Game/GameDetails.jsx'
import { ObavijestiPoker } from '../../Components/Layout/ObavijestiPoker.jsx'
import { Game } from '../../Components/Game/Game.jsx'

import { Banners } from '../../Components/Banner/Banners.jsx'
import { MojCasino } from '../../Components/Casino/MojCasino.jsx'
import { BonusItem } from '../../Components/Bonuses/BonusItem.jsx'
import { MaratonPobjednici } from '../../Components/Casino/MaratonPobjednici.jsx'


import { MaratonHappyHour } from '../../Components/Casino/MaratonHappyHour.jsx'
import { MaratonHappyHourPobjednici } from '../../Components/Casino/MaratonHappyHourPobjednici.jsx'

import { LastManStanding } from '../../Components/Casino/LastManStanding.jsx'



export class PokerDownload extends React.Component {


    constructor(props) {
        super(props);

        this.createDownloadEvent = this.createDownloadEvent.bind(this);
        casino.utils.createPageGoogleTagManagerEvent('Preuzimanje', '', 'poker');
    }


    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.showMenuFn(false);
    }

    createDownloadEvent(e) {
        casino.utils.createGoogleTagManagerEvent({
            'event': 'poker_download',
            'os': casino.utils.getOperatingSystem()
        });

        var downloadPokerEventId = 55;
        casino.repos.eventRepo.create(downloadPokerEventId);
    }
    render() {
        return <div>
            <Header key="header" {...this.state} {...this.props} userHeader="true" headerText="Preuzimanje" headerBackUrl="/poker"></Header>


            <div id="page-wrapper" className="white padding-2p-on-mobile border-on-tablet margin-1p-on-tablet">

                <h1 className="margin-bottom mobile-hidden">Preuzimanje</h1>

                <div className="padding-sides-medium-2">
                    <div className="max-width-40">
                        <div className="poker-download"></div>
                        <div className="padding-sides-medium-2 margin-bottom-small">
                            <a className="btn large fill green btn-3 as-block" href={casino.config.urls.pokerApk} onClick={this.createDownloadEvent}>
                                <span className="container">
                                    <span className="icon ico-android"></span><span className="main-text">SUPERSPORT POKER</span><span className="download-text">Preuzmi aplikaciju</span>
                                </span>
                            </a>
                        </div>
                        <div className="margin-bottom">
                            <span className="text-center as-block text-info">Podržano od Android verzije 8.1</span>
                        </div>
                        <div className="margin-top margin-bottom">
                            <br />
                            <span className="text as-block">
                                Ako niste uspješno preuzeli Poker onda na mobitelu:<br /><br />
                                1. uđite u izbornik <b>"Postavke"</b> <br />
                                2. odaberite <b>"Sigurnost"</b><br />
                                3. omogućite instalaciju aplikacija iz <b>"Nepoznati izvori"</b><br />
                                4. kliknite <b>"U REDU"</b><br />
                                5. ponovo preuzmite <b>POKER</b><br />
                            </span>
                            <br />
                        </div>

                        <div className="poker-download-sigurnost-1"></div>
                        <div className="margin-bottom">
                            <span className="text-center as-block text-info">Izbornik "Postavke" {">"} "Sigurnost"</span>
                        </div>

                        <div className="poker-download-sigurnost-2"></div>
                        <div className="margin-bottom">
                            <span className="text-center as-block text-info">Prihvaćanje uvjeta; Kliknite "U REDU"</span>
                        </div>

                        <div className="margin-bottom">
                            <br />
                        </div>
                    </div>
                </div>
            </div>
            <div className="poker-text-info">
                <div className="poker-container-wider turniri">
                    <section className="padding-sides-medium-2">
                        <div className="title-container">
                            <h1 className="v3">SuperSport online poker</h1>
                            <img src="content/images/poker/-e-icon_online_poker.png" alt="SuperSport Online Poker"></img>
                        </div>
                        <br />
                        <p>
                            Dobrodošli na stranice najveće Online Poker mreže u Hrvatskoj – SuperSport Poker gdje možete igrati on line Poker 24 sata dnevno, 7 dana u tjednu i to protiv igrača iz cijele Hrvatske. Pridružite nam se na stolovima svaki dan od 0 - 24 i započnite svoju Texas Hold'em avanturu na jednom od mnogobrojnih turnira ili pokažite svoje znanje i vještinu na Poker Cash stolovima.
                        </p>
                        <br />
                        <p>
                            Texas Hold'em poker kao i ostale varijante Pokera, možete igrati na vašim mobilnim uređajima (Android i iOS) ili na vašim računalima i to iz udobnosti vašeg doma. Pomoću chat opcije možete razgovarati s ostalim igračima i iskoristiti prirodu Pokera kao najpopularnije društvene igre današnjice! SuperSport Poker ima u ponudi i besplatne Poker turnire u kojima možeš osvojiti pravi novac!
                        </p>
                    </section>
                    <div className="delimiter"></div>
                    <section className={"padding-sides-medium-2"}>
                        <div className="title-container">
                            <h2 className="subtitles">Preuzimanje</h2>
                        </div>
                        <p className="small-darker">
                            SuperSport Poker aplikacija dostupna Vam je za preuzimanje u tri laka koraka! Instalirajte SuperSport Poker aplikaciju na vaš željeni uređaj, postavite način igre u skladu s vlastitim znanjima i vještinama i zaigrajte online Poker već danas! Kreiraj Poker alias i personalizirani avatar, temu karata, odaberite sobu za igru i organiziraj svoju nezaboravnu Poker večer samo na SuperSport Pokeru.
                        </p>
                    </section>
                </div>
            </div>

            <ObavijestiPoker {...this.props}></ObavijestiPoker>


        </div>

    }
};
